

// ANIMATIONS FOOTER

// Changemetn couleur background
gsap.to('footer', { 
	backgroundColor: '#fff',
	backgroundColor: '#000',
	scrollTrigger: {
		trigger: 'footer',
		start: 'top+=250 bottom',
		end: 'top+=650 bottom',
		scrub: true,
		invalidateOnRefresh: true,
	}
});

// Apparition textes
var divs_flou = ['.socials_container', '.logo_footer', '.row'];
divs_flou.forEach(div => {
	gsap.to('footer '+div, { 
		filter: 'blur(0px)',
		opacity: '1',
		scrollTrigger: {
			trigger: 'footer '+div,
			start: 'center bottom',
			end: 'center bottom-=150',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});
});